// Coin symbol to SEO-friendly slug mapping
const CATEGORY_MAP = {
  BTC: 'bitcoin',
  ETH: 'ethereum',
  SOL: 'solana',
  XRP: 'ripple',
  DOGE: 'dogecoin',
  ADA: 'cardano',
  AVAX: 'avalanche',
  LINK: 'chainlink',
  DOT: 'polkadot',
  MATIC: 'polygon',
  UNI: 'uniswap',
  ATOM: 'cosmos',
  LTC: 'litecoin',
  ETC: 'ethereum-classic',
  XLM: 'stellar',
  NEAR: 'near-protocol',
  APT: 'aptos',
  ARB: 'arbitrum',
  OP: 'optimism',
  SUI: 'sui',
  SEI: 'sei',
  TIA: 'celestia',
  JUP: 'jupiter',
  WIF: 'dogwifhat',
  PEPE: 'pepe',
  BONK: 'bonk',
  SHIB: 'shiba-inu',
  FLOKI: 'floki',
  INJ: 'injective',
  FET: 'fetch-ai',
  RNDR: 'render',
  TAO: 'bittensor',
  FIL: 'filecoin',
  HBAR: 'hedera',
  IMX: 'immutable',
  MKR: 'maker',
  AAVE: 'aave',
  SNX: 'synthetix',
  CRV: 'curve',
  ORDI: 'ordi',
  STX: 'stacks',
  RUNE: 'thorchain',
  TRX: 'tron',
  TON: 'toncoin',
  ALGO: 'algorand',
  VET: 'vechain',
  SAND: 'sandbox',
  MANA: 'decentraland',
  AXS: 'axie-infinity',
  HYPE: 'hyperliquid',
  EOS: 'eos',
  BNB: 'bnb'
};

// Reverse map: slug -> symbol
const SLUG_TO_SYMBOL = {};
for (const [symbol, slug] of Object.entries(CATEGORY_MAP)) {
  SLUG_TO_SYMBOL[slug] = symbol;
}

// Set of all category slugs for quick lookup
const CATEGORY_SLUGS = new Set(Object.values(CATEGORY_MAP));

export function getSlugFromSymbol(symbol) {
  return CATEGORY_MAP[symbol?.toUpperCase()] || null;
}

export function getSymbolFromSlug(slug) {
  return SLUG_TO_SYMBOL[slug?.toLowerCase()] || null;
}

export function isCategorySlug(str) {
  return CATEGORY_SLUGS.has(str?.toLowerCase());
}

export { CATEGORY_MAP, SLUG_TO_SYMBOL, CATEGORY_SLUGS };

export default CATEGORY_MAP;
